module.exports = __webpack_public_path__ + "img/max-file-content-image-repeat.5814ff5b.svg";